import Axios, { InternalAxiosRequestConfig } from 'axios';

import { API_URL } from '@/config';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { showNotification } from '@/utils/notificationUtils';
import moment from 'moment-timezone';
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = storage.getToken();
  if (token) {
    config.headers.authorization = `${token}`;
  }
  config.headers.Accept = 'application/json';
  config.headers['Cache-Control'] = 'no-cache';
  config.headers.Pragma = 'no-cache';
  config.headers.Expires = '0';
  config.headers.tz = moment.tz.guess(true);
  config.params = { ...config.params, _: Date.now() };
  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    if (response.headers['content-type'] === 'text/csv; charset=utf-8') {
      return response;
    } else {
    if (response?.data?.result?.status) {
      return response.data.responseData;
    } else {
      const message = response?.data?.errors[0]?.message;
      showNotification({
        type: 'error',
        title: message,
      });
      return Promise.reject(response?.data);
    }
  }
  },
  (error) => {
    console.log('*************', error);
    const arr = ['ERR020'];
    let canIgnore = false;
    if (
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message)
    ) {
      let message = error.response?.data?.message || error.message;
      if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
        message = `${error.response?.data?.errors[0]?.message}`;
        if (arr.includes(error.response?.data?.errors[0]?.code)) {
          canIgnore = true;
        }
        if (message.includes('field is required') > 0) {
          message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
        }
      }
      if (!canIgnore) {
        showNotification({
          type: 'error',
          title: message,
        });
      }
    }

    return Promise.reject(error);
  }
);
